import { useState } from 'react';

const galleryImages = [
  {
    id: 1,
    url: 'https://public.readdy.ai/ai/img_res/a639c109c16d3ae2cca326c149f9748b.jpg',
    alt: 'Tandem paragliding over mountains'
  },
  {
    id: 2,
    url: 'https://readdy.ai/api/search-image?query=Paragliding%20takeoff%20moment%2C%20pilot%20and%20passenger%20running%20on%20mountain%20slope%2C%20colorful%20paraglider%20inflating%2C%20exciting%20launch%20scene%2C%20adventure%20sports%20action%2C%20natural%20mountain%20setting%2C%20clean%20background&width=800&height=600&seq=gallery-img-2&orientation=landscape',
    alt: 'Takeoff preparation'
  },
  {
    id: 3,
    url: 'https://readdy.ai/api/search-image?query=Aerial%20view%20from%20paraglider%20cockpit%2C%20passenger%20enjoying%20flight%20with%20arms%20spread%2C%20stunning%20landscape%20below%2C%20first%20person%20perspective%2C%20adventure%20tourism%2C%20blue%20sky%20and%20green%20valleys%2C%20simple%20clean%20composition&width=800&height=600&seq=gallery-img-3&orientation=landscape',
    alt: 'Flying high above the landscape'
  },
  {
    id: 4,
    url: 'https://readdy.ai/api/search-image?query=Paragliding%20landing%20approach%2C%20pilot%20and%20passenger%20coming%20in%20for%20smooth%20landing%2C%20green%20landing%20field%2C%20professional%20technique%2C%20adventure%20sports%20photography%2C%20natural%20outdoor%20setting%2C%20clean%20simple%20background&width=800&height=600&seq=gallery-img-4&orientation=landscape',
    alt: 'Smooth landing'
  },
  {
    id: 5,
    url: 'https://readdy.ai/api/search-image?query=Happy%20paragliding%20passenger%20smiling%20during%20flight%2C%20thumbs%20up%20gesture%2C%20enjoying%20tandem%20experience%2C%20safety%20harness%20visible%2C%20blue%20sky%20background%2C%20joyful%20adventure%20moment%2C%20simple%20clean%20composition&width=800&height=600&seq=gallery-img-5&orientation=landscape',
    alt: 'Happy flyer enjoying the experience'
  },
  {
    id: 6,
    url: 'https://readdy.ai/api/search-image?query=Sunset%20paragliding%20flight%2C%20golden%20hour%20lighting%2C%20silhouette%20of%20tandem%20paraglider%20against%20orange%20sky%2C%20romantic%20peaceful%20flight%2C%20beautiful%20natural%20colors%2C%20simple%20horizon%20background&width=800&height=600&seq=gallery-img-6&orientation=landscape',
    alt: 'Sunset flight'
  }
];

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  return (
    <section id="gallery" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Flight Gallery
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Capture the magic of flight through the eyes of our adventurers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image) => (
            <div 
              key={image.id}
              className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
              onClick={() => setSelectedImage(image.id)}
            >
              <img 
                src={image.url}
                alt={image.alt}
                className="w-full h-80 object-cover object-top transform group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <p className="text-white p-4 font-semibold">{image.alt}</p>
              </div>
              <div className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-zoom-in-line text-xl text-gray-900"></i>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox */}
        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button 
              className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer"
              onClick={() => setSelectedImage(null)}
            >
              <i className="ri-close-line text-3xl text-white"></i>
            </button>
            <img 
              src={galleryImages.find(img => img.id === selectedImage)?.url}
              alt={galleryImages.find(img => img.id === selectedImage)?.alt}
              className="max-w-full max-h-full object-contain"
            />
          </div>
        )}
      </div>
    </section>
  );
}
